import { gql } from '@apollo/client';

export const PROPERTY_FRAGMENTS = gql`
  fragment PropertyListingDynamic on PropertyTypeInterface {
    uri
    available
    id
    fullAddress
    relativeUrl
    remoteId: id
    businessId
    primaryCategory
    aliasUrl
    commercial
    rentalPrice
    salesPrice
    sellingState
    pricePrefix
    rentalPricePerWeek
    propertyType
    propertySubType
    bedrooms
    tenure
    furnished
    bathrooms
    receptions
    roomMetrics
    roomImperials
    description
    riverside
    managed
    zeroDeposit
    helpToBuy
    propertyAge
    sharedOwnership
    availableLongLet
    availableShortLet
    forSaleAndToLet
    openDay
    virtualViewings
    branch {
      id
      remoteId: id
      businessProfile {
        businessName
      }
    }
    address {
      streetname
      town
      outwardCode
    }

    ... on DevelopmentResalePropertyType {
      developmentName
      developmentMaxPrice
      developmentMinPrice
      plots {
        plotNumber
        propertyType
      }
      images {
        photographs {
          imagePath
          largestImagePath
          width
          height
          filename
          mimeType
        }
      }
    }
    images {
      photographs {
        imagePath
        largestImagePath
        width
        height
        filename
        mimeType
      }
    }
  }
`;

export const GET_PROPERTIES = gql`
  query SearchProperties(
    $age: [String]
    $areas: [String]
    $bathrooms: [String]
    $bedrooms: [String]
    $bedroomsMinimum: Int
    $category: SearchCategory!
    $currencyid: Int
    $first: Int
    $lastBuildDateTime: DateTime
    $multiSearch: String
    $newhomes: Boolean
    $onlynewhomes: Boolean
    $page: Int
    $priceHighest: Int
    $priceLowest: Int
    $propertyStyle: [String]
    $propertyType: [String]
    $receptions: [String]
    $riverside: Boolean
    $kfh: Boolean
    $longlet: Boolean
    $shortlet: Boolean
    $tenure: [String]
    $furnishState: [String]
    $type: TypeOfSearch
    $unavailable: Boolean
    $underoffer: Boolean
    $sort: SortSearch
    $commercialArea: String
    $commercialPropertyType: String
    $commercialSize: Int
    $commercialSizemax: Int
    $lat: Float
    $long: Float
    $nearme: Boolean
    $radius: Float
  ) {
    properties {
      propertySearch(
        bedrooms: $bedroomsMinimum
        category: $category
        currencyid: $currencyid
        fage: $age
        farea: $areas
        fbathroom: $bathrooms
        fbedroom: $bedrooms
        freception: $receptions
        fstyle: $propertyStyle
        ftenure: $tenure
        ffurnish: $furnishState
        ftype: $propertyType
        lastBuildDateTime: $lastBuildDateTime
        multisearch: $multiSearch
        newhomes: $newhomes
        onlynewhomes: $onlynewhomes
        price: $priceLowest
        pricemax: $priceHighest
        riverside: $riverside
        kfh: $kfh
        longlet: $longlet
        shortlet: $shortlet
        type: $type
        unavailable: $unavailable
        underoffer: $underoffer
        sort: $sort
        commercialArea: $commercialArea
        commercialPropertyType: $commercialPropertyType
        commercialSize: $commercialSize
        commercialSizemax: $commercialSizemax
        lat: $lat
        long: $long
        nearme: $nearme
        radius: $radius
      ) {
        propertyEndpointApi
        fallBackSearch {
          fallbackSearch
          fallbackSearchReason
        }
        multiSearch {
          displayName
          multiSearch
        }
        canonicalSearch {
          url
        }

        seo {
          title
          metaDescription
          h1
        }
        banners {
          banner
          id
          position
        }
        searchFacets {
          areas {
            facet
            value
            count
          }
          bedrooms {
            facet
            value
            count
          }
          propertyType {
            facet
            value
            count
          }
          propertyStyle {
            facet
            value
            count
          }

          bathrooms {
            facet
            value
            count
          }
          receptions {
            facet
            value
            count
          }
          riverside {
            facet
            value
            count
          }
          tenure {
            facet
            value
            count
          }
          furnishState {
            facet
            value
            count
          }
          class {
            facet
            value
            count
          }
        }
        propertyEndpointApi
        properties(first: $first, page: $page) {
          totalCount
          pageInfo {
            hasNextPage
            hasPreviousPage
            endCursor
            startCursor
          }
          edges {
            cursor
            node {
              __typename
              uri
              available
              id
              fullAddress
              relativeUrl
              remoteId: id
              businessId
              primaryCategory
              aliasUrl
              commercial
              rentalPrice
              salesPrice
              sellingState
              pricePrefix
              rentalPricePerWeek
              propertyType
              propertySubType
              bedrooms
              tenure
              propertyStyle
              furnished
              bathrooms
              receptions
              roomMetrics
              roomImperials
              description
              riverside
              summary
              managed
              zeroDeposit
              helpToBuy
              propertyAge
              sharedOwnership
              availableLongLet
              availableShortLet
              forSaleAndToLet
              openDay
              virtualViewings
              branch {
                id
                remoteId: id
                businessProfile {
                  businessName
                }
              }

              address {
                streetname
                town
                outwardCode
              }

              ... on ResidentialRentalPropertyType {
                whatsApp {
                  whatsAppEnabled
                  whatsAppFullUrl
                }
              }
              ... on PlotResalePropertyType {
                whatsApp {
                  whatsAppEnabled
                  whatsAppFullUrl
                }
              }
              ... on DevelopmentResalePropertyType {
                whatsApp {
                  whatsAppEnabled
                  whatsAppFullUrl
                }
                developmentName
                developmentMaxPrice
                developmentMinPrice
                plots {
                  plotNumber
                  propertyType
                }
                images {
                  photographs {
                    imagePath
                    largestImagePath
                    width
                    height
                    filename
                    mimeType
                  }
                }
              }
              images {
                photographs {
                  imagePath
                  largestImagePath
                  width
                  height
                  filename
                  mimeType
                }
              }
            }
          }
        }
      }
    }
  }
`;
export const GET_PROPERTIES_SEO = gql`
  query SearchPropertiesSEO(
    $age: [String]
    $areas: [String]
    $bathrooms: [String]
    $bedrooms: [String]
    $bedroomsMinimum: Int
    $category: SearchCategory!
    $currencyid: Int
    $lastBuildDateTime: DateTime
    $multiSearch: String
    $newhomes: Boolean
    $onlynewhomes: Boolean
    $priceHighest: Int
    $priceLowest: Int
    $propertyStyle: [String]
    $propertyType: [String]
    $receptions: [String]
    $riverside: Boolean
    $kfh: Boolean
    $longlet: Boolean
    $shortlet: Boolean
    $tenure: [String]
    $furnishState: [String]
    $type: TypeOfSearch
    $unavailable: Boolean
    $underoffer: Boolean
    $sort: SortSearch
    $commercialArea: String
    $commercialPropertyType: String
    $commercialSize: Int
    $commercialSizemax: Int
    $lat: Float
    $long: Float
    $nearme: Boolean
    $radius: Float
  ) {
    properties {
      propertySearch(
        bedrooms: $bedroomsMinimum
        category: $category
        currencyid: $currencyid
        fage: $age
        farea: $areas
        fbathroom: $bathrooms
        fbedroom: $bedrooms
        freception: $receptions
        fstyle: $propertyStyle
        ftenure: $tenure
        ffurnish: $furnishState
        ftype: $propertyType
        lastBuildDateTime: $lastBuildDateTime
        multisearch: $multiSearch
        newhomes: $newhomes
        onlynewhomes: $onlynewhomes
        price: $priceLowest
        pricemax: $priceHighest
        riverside: $riverside
        kfh: $kfh
        longlet: $longlet
        shortlet: $shortlet
        type: $type
        unavailable: $unavailable
        underoffer: $underoffer
        sort: $sort
        commercialArea: $commercialArea
        commercialPropertyType: $commercialPropertyType
        commercialSize: $commercialSize
        commercialSizemax: $commercialSizemax
        lat: $lat
        long: $long
        nearme: $nearme
        radius: $radius
      ) {
        fallBackSearch {
          fallbackSearch
        }
        canonicalSearch {
          url
        }
        seo {
          title
          metaDescription
        }
      }
    }
  }
`;

export const GET_MAP_PROPERTIES = gql`
  query SearchPropertiesMap(
    $age: [String]
    $areas: [String]
    $bathrooms: [String]
    $bedrooms: [String]
    $bedroomsMinimum: Int
    $category: SearchCategory!
    $currencyid: Int
    $first: Int
    $lastBuildDateTime: DateTime
    $multiSearch: String
    $newhomes: Boolean
    $onlynewhomes: Boolean
    $page: Int
    $priceHighest: Int
    $priceLowest: Int
    $propertyStyle: [String]
    $propertyType: [String]
    $receptions: [String]
    $riverside: Boolean
    $kfh: Boolean
    $longlet: Boolean
    $shortlet: Boolean
    $tenure: [String]
    $furnishState: [String]
    $type: TypeOfSearch
    $unavailable: Boolean
    $underoffer: Boolean
    $sort: SortSearch
    $commercialArea: String
    $commercialPropertyType: String
    $commercialSize: Int
    $commercialSizemax: Int
    $lat: Float
    $long: Float
    $nearme: Boolean
    $radius: Float
  ) {
    properties {
      propertySearch(
        bedrooms: $bedroomsMinimum
        category: $category
        currencyid: $currencyid
        fage: $age
        farea: $areas
        fbathroom: $bathrooms
        fbedroom: $bedrooms
        freception: $receptions
        fstyle: $propertyStyle
        ftenure: $tenure
        ffurnish: $furnishState
        ftype: $propertyType
        lastBuildDateTime: $lastBuildDateTime
        multisearch: $multiSearch
        newhomes: $newhomes
        onlynewhomes: $onlynewhomes
        price: $priceLowest
        pricemax: $priceHighest
        riverside: $riverside
        kfh: $kfh
        longlet: $longlet
        shortlet: $shortlet
        type: $type
        unavailable: $unavailable
        underoffer: $underoffer
        sort: $sort
        commercialArea: $commercialArea
        commercialPropertyType: $commercialPropertyType
        commercialSize: $commercialSize
        commercialSizemax: $commercialSizemax
        lat: $lat
        long: $long
        nearme: $nearme
        radius: $radius
        map: true
      ) {
        branches {
          id
          salesLat
          salesLon
          lettingsLat
          lettingsLon
        }
        properties(first: $first, page: $page) {
          totalCount
          pageInfo {
            hasNextPage
            hasPreviousPage
            endCursor
            startCursor
          }
          edges {
            cursor
            node {
              __typename
              available
              id
              remoteId: id
              businessId
              primaryCategory
              latitude
              longitude
            }
          }
        }
      }
    }
  }
`;

export const GET_MAP_PROPERTIES_NO_BRANCHES = gql`
  query SearchPropertiesMapNoBranches(
    $age: [String]
    $areas: [String]
    $bathrooms: [String]
    $bedrooms: [String]
    $bedroomsMinimum: Int
    $category: SearchCategory!
    $currencyid: Int
    $first: Int
    $lastBuildDateTime: DateTime
    $multiSearch: String
    $newhomes: Boolean
    $onlynewhomes: Boolean
    $page: Int
    $priceHighest: Int
    $priceLowest: Int
    $propertyStyle: [String]
    $propertyType: [String]
    $receptions: [String]
    $riverside: Boolean
    $kfh: Boolean
    $longlet: Boolean
    $shortlet: Boolean
    $tenure: [String]
    $furnishState: [String]
    $type: TypeOfSearch
    $unavailable: Boolean
    $underoffer: Boolean
    $sort: SortSearch
    $commercialArea: String
    $commercialPropertyType: String
    $commercialSize: Int
    $commercialSizemax: Int
    $lat: Float
    $long: Float
    $nearme: Boolean
    $radius: Float
  ) {
    properties {
      propertySearch(
        bedrooms: $bedroomsMinimum
        category: $category
        currencyid: $currencyid
        fage: $age
        farea: $areas
        fbathroom: $bathrooms
        fbedroom: $bedrooms
        freception: $receptions
        fstyle: $propertyStyle
        ftenure: $tenure
        ffurnish: $furnishState
        ftype: $propertyType
        lastBuildDateTime: $lastBuildDateTime
        multisearch: $multiSearch
        newhomes: $newhomes
        onlynewhomes: $onlynewhomes
        price: $priceLowest
        pricemax: $priceHighest
        riverside: $riverside
        kfh: $kfh
        longlet: $longlet
        shortlet: $shortlet
        type: $type
        unavailable: $unavailable
        underoffer: $underoffer
        sort: $sort
        commercialArea: $commercialArea
        commercialPropertyType: $commercialPropertyType
        commercialSize: $commercialSize
        commercialSizemax: $commercialSizemax
        lat: $lat
        long: $long
        nearme: $nearme
        radius: $radius
        map: true
      ) {
        properties(first: $first, page: $page) {
          totalCount
          pageInfo {
            hasNextPage
            hasPreviousPage
            endCursor
            startCursor
          }
          edges {
            cursor
            node {
              __typename
              available
              id
              remoteId: id
              businessId
              primaryCategory
              latitude
              longitude
            }
          }
        }
      }
    }
  }
`;

export const GET_PROPERTY_BY_ID = gql`
  query GetPropertyById($id: ID!) {
    properties {
      __typename
      property(id: $id) {
        __typename
        available
        id
        uri
        fullAddress
        relativeUrl
        remoteId: id
        businessId
        primaryCategory
        aliasUrl
        commercial
        rentalPrice
        salesPrice
        sellingState
        pricePrefix
        rentalPricePerWeek
        propertyType
        propertySubType
        propertyStyle
        summary
        councilTaxBand
        bedrooms
        tenure
        furnished
        bathrooms
        receptions
        roomMetrics
        roomImperials
        description
        riverside
        managed
        zeroDeposit
        helpToBuy
        propertyAge
        sharedOwnership
        availableLongLet
        availableShortLet
        forSaleAndToLet
        openDay
        virtualViewings
        branch {
          id
          remoteId: id
          businessProfile {
            businessName
          }
        }
        address {
          streetname
          town
          outwardCode
        }
        ... on DevelopmentResalePropertyType {
          developmentName
          developmentMaxPrice
          developmentMinPrice
          plots {
            plotNumber
            propertyType
            bedrooms
          }
          images {
            developmentImages {
              largestImagePath
              width
              height
              filename
              mimeType
            }
            photographs {
              largestImagePath
              width
              height
              filename
              mimeType
            }
          }
        }
        images {
          photographs {
            largestImagePath
            width
            height
            filename
            mimeType
          }
        }
      }
    }
  }
`;

export const AUTOCOMPLETE_SEARCH = gql`
  query autoCompleteSearch($search: String!, $category: SearchCategory!, $type: SearchType) {
    propertySearchMeta {
      autoComplete(search: $search, category: $category, searchType: $type) {
        autoCompleteItems {
          displayName
          multiSearch
          ID: multiSearch
        }
      }
    }
  }
`;

export const PROPERTY_BY_REF = gql`
  query propertyByRef($ref: ID!) {
    properties {
      propertyByRef(id: $ref) {
        __typename
        relativeUrl
        uri
        available
        id
        remoteId: id
        businessId
        primaryCategory
        aliasUrl
        address {
          streetname
          town
          outwardCode
        }
        latitude
        longitude
        commercial
        roomImperials
        roomMetrics
        rentDetails
        rentalPricePerWeek
        rentalPrice
        salesPrice
        pricePrefix
        councilTaxBand
        sellingState
        openDay
        openDayDateEnd
        openDayDateStart
        furnished
        propertyAge
        forSaleAndToLet
        availableLongLet
        availableShortLet
        managed
        zeroDeposit
        helpToBuy
        sharedOwnership
        propertyType
        propertySubType
        riverside
        tenure
        bedrooms
        receptions
        bathrooms
        description
        salesDetails
        termsAndConditions
        businessRates
        location
        propertyStyle
        additionalDescription
        features {
          description
        }
        propertyBrochure
        virtualViewings
        virtualViewingsUrl
        firstImage {
          largestImagePath
          width
          height
          filename
          mimeType
        }
        images {
          photographsSmall: photographs {
            largestImagePath
            width
            height
            filename
            mimeType
          }
          photographs {
            largestImagePath
            width
            height
            filename
            mimeType
          }
          epc {
            largestImagePath
            width
            height
            filename
            mimeType
          }

          floorplans {
            largestImagePath
            width
            height
            filename
            mimeType
          }
          floorplansSmall: floorplans {
            largestImagePath
            width
            height
            filename
            mimeType
          }
        }
        stations {
          name
          trainStationType
          distance
        }
        specifications {
          detail
          category
        }
        area {
          id
          guideExcerpt
          relativeUrl
          name
          region {
            name
            mediaSet {
              media {
                media {
                  filePath
                  width
                  height
                  filename
                  mimeType
                }
              }
            }
          }
          mediaSet {
            media {
              media {
                filePath
                width
                height
                filename
                mimeType
              }
            }
          }
        }

        branch {
          id
          name
          remoteId: id
          relativeUrl
          isSales
          isLettings
          salesLat
          salesLon
          lettingsLat
          lettingsLon
          openingHours
          googleMapLinkRental
          googleMapLinkResales
          mediaSet {
            media {
              media {
                filePath
                width
                height
                filename
                mimeType
              }
              role
            }
          }
          businessProfile {
            businessName
            salesContactDetails {
              ...ContactDetailsLive
            }
            lettingsContactDetails {
              ...ContactDetailsLive
            }
          }
          lettingsBranchImage {
            filePath
            width
            height
            filename
            mimeType
          }
          salesBranchImage {
            filePath
            width
            height
            filename
            mimeType
          }
        }
        ... on ResidentialRentalPropertyType {
          whatsApp {
            whatsAppEnabled
            whatsAppFullUrl
          }
        }
        ... on DevelopmentResalePropertyType {
          developmentName
          developmentMaxPrice
          developmentMinPrice
          plots {
            plotNumber
            floorLevel
            propertyType
            sellingState
            salesPrice
            bedrooms
            relativeUrl
            available
          }
          images {
            developmentImages {
              largestImagePath
              width
              height
              filename
              mimeType
            }
          }
        }
        ... on PlotResalePropertyType {
          development {
            relativeUrl
            developmentName
            description
          }
          relatedPlots {
            plotNumber
            floorLevel
            propertyType
            sellingState
            salesPrice
            bedrooms
            relativeUrl
            available
          }
        }
        seo {
          ...SEOLive
        }
      }
    }
  }
`;
